<!--
 * @Descripttion:
 * @Author: kongweiqiang
 * @Date: 2021-08-31 15:42:57
 * @LastEditors: kongweiqiang
 * @LastEditTime: 2021-09-26 16:04:51
-->
<!--
 * @Descripttion:
 * @Author: kongweiqiang
 * @Date: 2021-08-31 15:14:52
 * @LastEditors: kongweiqiang
 * @LastEditTime: 2021-08-31 15:38:59
-->
<template>
  <div>
    <div class="instructions" v-html='content'>
    </div>
    <!-- <div class="instructions">
      <h3>一、报考时间</h3>
      <p>
        考试将于2021年9月13日至2021年9月25日进行，每名招标代理从业人员首次考试未通过的请于2021年9月25日至2021年9月30日进行补考。考试系统将于9月30日关闭。
      </p>
      <h3>
        二、考试说明
      </h3>
      <p>
        1.学习完平台上所有必修课程后，才可参与考试。
      </p>
      <p>
        2.考试时长为60分钟，共计50题，题型为10道判断题，20道单选题，20道多选题，每题2分，考试得分60分及以上为通过考试。
      </p>
      <p>
        3.考试题目请谨慎作答，本次考试不可以修改已经作答过题目。提交每道试题的答案后，系统会立即反馈答题结果。
      </p>
      <p>
        4.考试结束后，用户可以立即获得本次考试的成绩，本次考试的具体试卷和作答情况可在成绩查询页面查看。
      </p>
      <p>
        5.考试通过的人员会立即获得电子证书，电子证书的有效期为2021年09月30日-2022年09月29日。
      </p>
      <p>
        6.对于2021年9月13日至2021年9月25日之间未参加初次考试的人员，可以直接报名参加2021年9月25日至2021年9月30日的补考。
      </p>
      <p>
        7.本次考试以机构为单位，河北省建设工程招标投标协会会员单位可在规定时间内进行考试，未办理入会手续的单位请办理入会手续进行考试。
      </p>
      <h3>
        三、联系电话
      </h3>
      <p>
        市招标办：0311-89929198。
      </p>
      <p>
        技术咨询：0311-87820486、0311-86273887。
      </p>
    </div> -->
  </div>
</template>
<script>
export default {
  props: ['content']
}
</script>
<style  scoped>
h3 {
  font-size: 14px;
  margin: 5px 0;
}
p {
  margin: 7px 0;
  font-size: 14px;
}
</style>
